// extracted by mini-css-extract-plugin
export default {"project_paginate_number":"styles_project_paginate_number__Fuqh6","active":"styles_active__MRRnL","prev":"styles_prev__sRkpx","next":"styles_next__ARhmc"};